import React from "react";

// components
import Img from "components/Img";

export const EmptyDetails: React.FC = () => {
  return (<>
    <div className="empty-details__divider empty-details__divider-position-top" />
    <Img isSvg name="pointSvg" className="empty-details__image mb15" />
    <p className="empty-details__text text-align-cn">
      Here you will find detailed information on the selected target.<br /> To display information, you need to select
      one of
      the targets.
    </p>
    <div className="empty-details__divider empty-details__divider-position-bottom" />
  </>);
};

export default EmptyDetails;
